import styled from "styled-components";
import { Box, Button, Flex, Input, Tr } from "@chakra-ui/react";

export const ContabilidadeContainerText = styled(Box)`
  font-family: "Arial", sans-serif;
  background-color: #5292a2;
  padding: 15px 0;
  h1 {
    color: #fff;
    font-size: 23px;
    font-weight: 400;
    text-align: center;
  }
`;
export const ButtonSendModal = styled(Button)`
  width: 150px;
  margin-right: 1rem;
  letter-spacing: 1px;
  position: relative;
  z-index: 1;
  color: #3a7993;
  border-radius: 4px;
  transition: ease-out 0.3s;
  box-shadow: none !important;
  font-family: 2rem;
  height: 50px;
  outline: none;
  font-size: 18px;
  font-weight: 600;
  border: 1px solid #3a7993;
  background-color: white;
  &:active {
    transform: translateY(2px);
  }
  &:hover,
  &:focus {
    color: white;
    border: 1px solid #3a7993;
    transform: scale(1.05);
  }
  &::before {
    transition: 0.5s all ease;
    position: absolute;
    top: 0;
    left: 50%;
    right: 50%;
    bottom: 0;
    opacity: 0;
    content: "";
    background-color: #3a7993;
  }
  &:hover::before,
  &:focus::before {
    transition: 0.5s all ease;
    left: 0;
    right: 0;
    opacity: 1;
    z-index: -1;
  }
`;
export const ContabilidadeContainerTable = styled(Flex)`
  height: 70px;
  justify-content: space-between;
  width: 100%;
  cursor: pointer;
  &:hover {
    background-color: #f4ddd5;
  }
  &:nth-child(even) {
    &:hover {
      background-color: #f4ddd5;
    }
    background-color: #dddddd;
  }

  &:disabled {
    &:hover {
      background-color: #dddddd;
    }
  }
`;
export const ContabilidadeInputModal = styled(Input)`
  background-color: white;
  font-size: 16px;
  margin: 0 5px;
  width: 70px;
  &::placeholder {
    text-align: center;
  }

  &:disabled {
    opacity: 1!important;
    background-color: #cecece;
  }

  @media screen and (max-width: 1366px) {
    font-size: 12px;
    width: 120px;
  }
`;
export const ContabilidadeContainerTableModal = styled(Tr)`
  align-items: center;
  text-align: center;
  height: 50px;
  cursor: pointer;
  background-color: #f4f5f5;
  color: #f4ddd5;

  td {
    font-size: 14px;
    text-align: center;
  }

  &:hover {
    background-color: #f4ddd5;
  }
  &:nth-child(even) {
    &:hover {
      background-color: #f4ddd5;
    }
    background-color: #eeeeee;
  }
  @media screen and (max-width: 1366px) {
    td {
      font-size: 12px;
    }
  }
`;
export const TrHeader = styled(Tr)`
  th {
    color: #fff;
    text-align: center;
  }
`;

export const ContabilidadeFiltroContainer = styled(Flex)`
  margin: 0 auto;
  width: 100%;
  max-width: 1366px;
  justify-content: space-around;
  @media screen and (max-width: 1366px) {
    margin: -10px auto 0 auto;
  }
`;
export const ContabilidadeButtonFiltrar = styled.button`
  width: 150px;
  letter-spacing: 1px;
  position: relative;
  z-index: 1;
  border-radius: 4px;
  transition: ease-out 0.3s;
  height: 40px;
  color: white;
  margin: 0 auto;
  outline: none;
  font-weight: 600;
  background-color: #3a7993;
`;
export const ContabilidadeFlexButtonContainer = styled(Flex)`
  margin: 20px auto 0 auto;
  width: 100%;
  height: 50px;
  justify-content: center;
  /* animation: has-shown 2s cubic-bezier(0.785, 0.135, 0.15, 0.86) 0.2s forwards;
  @keyframes has-shown {
    from {
      opacity: 0;
      transform: translateY(50px);
    }
    to {
      opacity: 1;
      transform: none;
    }
  } */
`;
export const ContabilidadeBoxInputContainer = styled(Box)`
  position: relative;
  padding: 13px 0 0;
  margin-top: 20px;
  width: 200px;
  input {
    width: 100%;
    border: 0;
    border-bottom: 1px solid #3a7993;
    outline: 0;
    font-size: 1.3rem;
    color: black;
    padding: 7px 0;
    background: transparent;
    transition: border-color 0.2s;
    &:required,
    &:invalid {
      box-shadow: none;
    }

    &::placeholder {
      color: transparent;
    }

    &:placeholder-shown ~ .form__label {
      font-size: 1.3rem;
      cursor: text;
      top: 20px;
    }
  }
  input:focus {
    ~ .form__label {
      position: absolute;
      top: 0;
      display: block;
      transition: 0.2s;
      font-size: 1rem;
      color: #3a7993;
      font-weight: 700;
    }
    padding-bottom: 6px;
    font-weight: 700;
    border-width: 3px;
    border-image: linear-gradient(to right, #3a7993, #3a7993);
    border-image-slice: 1;
  }

  label {
    position: absolute;
    top: 0;
    display: block;
    transition: 0.2s;
    font-size: 1rem;
    color: #9b9b9b;
  }
`;
export const ContabilidadeFlexInput = styled(Flex)`
  width: 800px;
  justify-content: space-between;
  label {
    position: relative;
    top: 40px;
    left: 20px;
    color: #9b9b9b;
    font-weight: 500;
    font-size: 1.3rem;
    transition: 0.2s;
  }
  input {
    position: relative;
    left: -35px;
    font-size: 1.3rem;
    width: 215px;
    margin-top: 33px;
    border-bottom: 1px solid #3a7993;
    &:placeholder-shown ~ .label_data_saida {
      font-size: 1.3rem;
      cursor: text;
      top: 20px;
    }
  }

  input:focus {
    ~ .label_data_saida {
      position: absolute;
      top: 0;
      display: block;
      transition: 0.2s;
      font-size: 1rem;
      color: #3a7993;
      font-weight: 700;
      border-image: linear-gradient(to right, #3a7993, #3a7993);
    }
    ~ .label_data_pronto {
      position: absolute;
      top: 0;
      display: block;
      transition: 0.2s;
      font-size: 1rem;
      color: #3a7993;
      border-image: linear-gradient(to right, #3a7993, #3a7993);
      font-weight: 700;
    }
  }
`;

